<template lang="pug">
    section#video
        .wrapper
            div.content(v-html="$props.conteudo")
</template>

<script>
export default {
    name: "section-video",
    props: {
        conteudo: String
    }
}
</script>

<style lang="stylus" scoped src="./Video.styl"></style>